// extracted by mini-css-extract-plugin
export default {"web-url-container":"WebUrlView_web-url-container__XNbLB","web-url-iframe":"WebUrlView_web-url-iframe__0uNuq"};